{
  "chart": {
    "empty": {
      "description": "Ei tietoja saatavilla tälle ajanjaksolle.",
      "title": "Tietoja ei löytynyt"
    }
  },
  "date_picker": {
    "all_time": "Kaikki ajat",
    "confirm": "Vahvista",
    "current_quarter": "Nykyinen vuosineljännes",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Viimeiset {days} päivää",
    "last_n_months": "Viimeiset {months} kuukautta",
    "last_quarter": "Edellinen vuosineljännes",
    "last_year": "Viime vuosi",
    "lifetime": "Koko ajalta",
    "this_year": "Tämä vuosi",
    "today": "Tänään"
  },
  "document_viewer": {
    "sidebar_heading": "Sisällön yleiskatsaus"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "error": {
    "title": "Tapahtui virhe."
  },
  "factor_indicator": {
    "average": "Keskiarvo",
    "bad": "Kriittinen",
    "excellent": "Erinomainen",
    "good": "Hyvä"
  },
  "gauge_chart": {
    "empty": {
      "title": "Tietoja ei ole saatavilla",
      "tooltip": "Sinun resilienssipisteesi lasketaan"
    }
  },
  "locale": {
    "current": "Suomi",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Jatka palvelulla {provider}"
  },
  "search": {
    "no_options": "Ei vaihtoehtoja saatavilla.",
    "no_results": "Ei tuloksia löytynyt.",
    "placeholder": "Haku..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Sulje esikatselu",
      "open": "Laajenna esikatselunäkymää"
    }
  },
  "video_player": {
    "captions": "Tekstitykset",
    "captions_off": "Pois",
    "normal_speed": "Normaali",
    "playback_speed": "Toistonopeus"
  }
}
